import { render, staticRenderFns } from "./DialogUpdateCompany.vue?vue&type=template&id=59cd56df&scoped=true&"
import script from "./DialogUpdateCompany.vue?vue&type=script&lang=js&"
export * from "./DialogUpdateCompany.vue?vue&type=script&lang=js&"
import style0 from "./DialogUpdateCompany.vue?vue&type=style&index=0&id=59cd56df&lang=scss&scoped=true&"
import style1 from "./DialogUpdateCompany.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cd56df",
  null
  
)

export default component.exports